import { useState, useEffect } from 'react';
import CareerDial from './CareerDial';
import CareerDialClassic from './CareerDialClassic';
import PortfolioV3 from './pages/PortfolioV3';
import { useSiteSettings } from './hooks/useSiteSettings';
import { useCareerEvents } from './hooks/useCareerEvents';

function App() {
  const { settings } = useSiteSettings();
  const { events } = useCareerEvents();

  // Simple routing
  const [currentPath, setCurrentPath] = useState(() => {
    return window.location.pathname;
  });

  // Listen for route changes (popstate for browser back/forward)
  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleRouteChange);
    return () => window.removeEventListener('popstate', handleRouteChange);
  }, []);

  return (
    <div className="App relative min-h-screen bg-[#050505] overflow-hidden">
      {currentPath === '/timeline' ? (
        <CareerDial settings={settings} events={events} />
      ) : currentPath === '/classic' ? (
        <CareerDialClassic settings={settings} events={events} />
      ) : (
        <PortfolioV3 settings={settings} />
      )}
    </div>
  );
}

export default App;
